export default function() {
  return new Worker(__webpack_public_path__ + "import-worker.4e3346472bac7d52206f.worker.js");
}
